import { useState } from 'react'
import { Tabs } from '../../../../components/Tabs/Tabs'
import { CRMIntegrationSettings } from '../CRMIntegrationSettings'
import { ContactSyncSettings } from '../ContactSyncSettings'
import { CRMIntegrationTaskSettings } from '../CRMIntegrationTaskSettings'
import { Modal } from '../../../../components/Modal/Modal'
import { Modal as BootstrapModal, Tab } from 'react-bootstrap'

export type BlackDiamondSettingsModalProps = {
  show: boolean
  onHide: () => void
}

export const BlackDiamondSettingsModal: React.FC<BlackDiamondSettingsModalProps> = ({ show, onHide }) => {
  const [activeTabKey, setActiveTabKey] = useState<string>('blackDaimondMappings')
  const changeTab = (key: string | null): void => {
    if (key) {
      setActiveTabKey(key)
    }
  }

  const BlackDiamondSettingsModalBody = () => {
    return (
      <Tabs activeKey={activeTabKey} id='balck-diamond-settings' className='d-flex mb-3' onSelect={changeTab} mountOnEnter unmountOnExit>
        <Tab eventKey='blackDaimondMappings' title='Mappings'>
          <CRMIntegrationSettings serviceId='blackdiamond' onSaved={onHide} onCancelled={onHide} />
        </Tab>
        <Tab eventKey='blackDiamondSyncSettings' title='Contact Sync'>
          <ContactSyncSettings serviceId={'blackdiamond'} />
        </Tab>
        <Tab eventKey='blackDiamondTaskSettings' title='Tasks'>
          <CRMIntegrationTaskSettings serviceId='blackdiamond' />
        </Tab>
      </Tabs>
    )
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<BootstrapModal.Title>Edit SS&C BlackDiamond Edge Integration Settings</BootstrapModal.Title>}
      body={<BlackDiamondSettingsModalBody />}
    />
  )
}
